export const reportDataPolimedicationByMonth = {
  data: {
    rpp: '/COROTA/PolymedRatioByMonth',
    pts: 1,
    fr: true,
    dn: '',
    rp: '',
  },

  dataDownloadPDF: {
    rpp: '/COROTA/PolymedRatioByMonth',
    pts: 0,
    fmt: 2,
    dn: '',
    rp: '',
  },

  dataDownloadExcel: {
    rpp: '/COROTA/PolymedRatioByMonth',
    pts: 0,
    fmt: 3,
    dn: '',
    rp: '',
  },
  dataRenderReport: {
    rpp: '/COROTA/PolymedRatioByMonth',
    pts: 0,
    z: 100,
    htmf: false,
    fmt: 2,
    dl: false,
    dn: '',
    rp: '',
  },
};

export const reportDataPolimedication = {
  data: {
    rpp: '/COROTA/PolymedRatio',
    pts: 1,
    fr: true,
    dn: '',
    rp: '',
  },

  dataDownloadPDF: {
    rpp: '/COROTA/PolymedRatio',
    pts: 0,
    fmt: 2,
    dn: '',
    rp: '',
  },

  dataDownloadExcel: {
    rpp: '/COROTA/PolymedRatio',
    pts: 0,
    fmt: 3,
    dn: '',
    rp: '',
  },
  dataRenderReport: {
    rpp: '/COROTA/PolymedRatio',
    pts: 0,
    z: 100,
    htmf: false,
    fmt: 2,
    dl: false,
    dn: '',
    rp: '',
  },
};
